import axios, { InternalAxiosRequestConfig } from 'axios'

export const API_URL = import.meta.env.VITE_API_URL || 'https://api-qa.160digital.com'
export const SESSION_TOKEN_HEADER = 'Authorization'

export const getSessionTokenHeaders = (sessionToken: string) => ({
  [SESSION_TOKEN_HEADER]: `Bearer ${sessionToken}`
})

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error)
  }
)

export default apiClient
